import { forwardRef } from 'react'
import { TextInputField, TextInputFieldProps } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { CellFrame } from '@/core/architecture'

export const TextInputCell = forwardRef(
  (
    {
      titleProps,
      textFieldProps,
      error,
      ...props
    }: Omit<TextInputFieldProps, 't'>,
    ref
  ) => {
    const { t } = useTranslation('consolePreSaleCreate')
    return (
      <CellFrame>
        <TextInputField
          titleProps={{ ...titleProps, variant: 'h5', color: 'text.primary' }}
          textFieldProps={textFieldProps}
          ref={ref}
          {...props}
          error={error}
          t={t}
        />
      </CellFrame>
    )
  }
)
